import React, { useState } from "react";
import FadeLoader from "react-spinners/FadeLoader";
import { useDispatch, useSelector } from "react-redux";

const SaveAndSaveNext = (props) => {
  const handleClick = (label) => {
    // Find the first error key in the errors object
    const firstErrorKey = Object.keys(props.errors)[0];
    if (firstErrorKey) {
      props.setTouched({ [firstErrorKey]: true }); // Mark the field as touched
      // Scroll to the first error element when clicked
      if (props.firstErrorRef.current) {
        props.firstErrorRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    } else if (label !== "Save") {
      props.setSaveAndNext(true);
    }
  };

  return (
    <>
      {props.loading ? (
        <FadeLoader size={5} />
      ) : (
        <>
          <button
            className={`${"exam_button"}`}
            type="submit"
            onClick={() => handleClick("Save")}
          >
            Save
          </button>
          <button
            className={`${"exam_button"}`}
            type="submit"
            onClick={() => handleClick("Save & Next")}
          >
            Save & Next
          </button>
        </>
      )}
    </>
  );
};

export default SaveAndSaveNext;
